(() => {
  /**
   * Calculate scrollbar width and set as CSS variable
   * Works across all browsers including mobile
   */
  function calculateScrollbarWidth() {
    let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    // Fallback: use a temp element if result is 0 or negative
    if (scrollbarWidth <= 0) {
      const scrollDiv = document.createElement("div");
      scrollDiv.style.width = "100px";
      scrollDiv.style.height = "100px";
      scrollDiv.style.overflowY = "scroll";
      scrollDiv.style.position = "absolute";
      scrollDiv.style.top = "-9999px";

      document.documentElement.appendChild(scrollDiv);
      scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.documentElement.removeChild(scrollDiv);
    }

    document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
  }

  // Run on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", calculateScrollbarWidth);
  } else {
    calculateScrollbarWidth();
  }

  function debounce(fn, wait) {
    let timeout = null;
    return function (...args) {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        fn.apply(this, args);
        timeout = null;
      }, wait);
    };
  }
  const debouncedCalculateScrollbarWidth = debounce(calculateScrollbarWidth, 100);
  window.addEventListener("resize", debouncedCalculateScrollbarWidth);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', calculateScrollbarWidth);
  }
})();